interface IShopRibbonScope extends ng.IScope {
  selected: string;
  toggle(e: Event): void;
}

/**
 * @deprecated Should be converted into component!
 */
export class ShopRibbonController implements ng.IController {
  public static $inject = ['$scope'];

  constructor(private $scope: IShopRibbonScope) {
    this.$scope.selected = '';
    this.$scope.toggle = (e: Event) => {
      const target: HTMLInputElement = e.target as HTMLInputElement;
      const value: string = target.value;

      this.$scope.selected = this.$scope.selected === value ? '' : value;
      target.checked = this.$scope.selected !== '';
    };
  }
}
